<template>
  <div class="card">
    <div class="card-header">
      <h4 class="title"></h4>
    </div>
    <div v-if="selectedBetgame" class="card-content">
      <form>

        <div class="row">
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label>Spielregeln werden den Benutzer im Tippspiel unter dem Menupunkt 'Spielregeln' angezeigt (HTML-Formatierung).</label>
              <textarea rows="25" class="form-control border-input"
                        placeholder="Spielregeln"
                        v-model="selectedBetgame.rules">
              </textarea>
            </div>
          </div>
        </div>
        <div class="text-right" style="margin-top: 30px; margin-bottom: 30px;">
          <button type="submit" class="btn btn-info btn-fill btn-wd" @click.prevent="updateBetgame">
            Speichern
          </button>
        </div>
        <div class="clearfix"></div>
      </form>
    </div>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        selectedBetgame: {}
      }
    },
    created () {
      if (!this.$store.state.betgameData) {
        this.$store.dispatch('fetchBetgame', this.$store.state.betgame)
      }
    },
    mounted () {
      this.selectedBetgame = this.$store.state.betgameData
    },
    methods: {
      updateBetgame () {
        // alert('' + JSON.stringify(this.selectedBetgame))
        this.$store.dispatch('patchBetgame', {
          rules: this.selectedBetgame.rules
        })
          .then(() => {
            if (this.selectedBetgame) {
            }
            alert('Tippspiel-Daten wurden aktualisiert')
          })
          .catch(function (error) {
            this.$log.debug(error)
          })
          .finally(function () {
          })
      }
    },
    computed: {
      betgameId () {
        return '' + this.selectedBetgame.id
      }
    }
  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/BGEditRulesForm.vue